/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWorkspaceSchema
 */
export interface CreateWorkspaceSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkspaceSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkspaceSchema
     */
    organizationId: number;
}

/**
 * Check if a given object implements the CreateWorkspaceSchema interface.
 */
export function instanceOfCreateWorkspaceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "organizationId" in value;

    return isInstance;
}

export function CreateWorkspaceSchemaFromJSON(json: any): CreateWorkspaceSchema {
    return CreateWorkspaceSchemaFromJSONTyped(json, false);
}

export function CreateWorkspaceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkspaceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'organizationId': json['organization_id'],
    };
}

export function CreateWorkspaceSchemaToJSON(value?: CreateWorkspaceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'organization_id': value.organizationId,
    };
}

